export default __webpack_public_path__ + "static/media/CNo.49-2.8b1cfa5c.jpg";